import { PropsWithChildren } from 'react'

type Props = {
  href: string
}

export default function ExternalLink(props: PropsWithChildren<Props>) {
  return (
    <a className="font-bold underline" href={props.href} target="_blank" rel="noreferrer">
      {props.children}
    </a>
  )
}
